import script from "./productRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./productRequest.vue?vue&type=script&setup=true&lang=js"

import "./productRequest.vue?vue&type=style&index=0&id=4cf6e8ec&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf6e8ec"]])

export default __exports__